import React from 'react';
import PropTypes from 'prop-types';
import { POPULAR_JOB_COUNTRIES } from 'constants/popularJobLinks';
import styles from '../Footer.module.scss';

const LocationJobs = ({ omitHeading = false }) => {
  return (
    <ul className={styles.linkList}>
      {!omitHeading && (
        <li>
          <a href="/jobs">Find jobs by location</a>
        </li>
      )}
      {POPULAR_JOB_COUNTRIES.map((country) => (
        <li key={country.slug}>
          <a href={`/jobs/in/${country.slug}`}>{country.footerLabel}</a>
        </li>
      ))}
      <li>
        <a href="/jobs/categories">All job categories</a>
      </li>
      <li>
        <a href="/jobs">Find jobs worldwide</a>
      </li>
    </ul>
  );
};

LocationJobs.propTypes = {
  omitHeading: PropTypes.bool,
};

export default LocationJobs;
